import React, { useState } from "react";
import axios from "axios";

async function AuthUser(email) {
  // get client ip

  // Pendapatan lain-lain
  const resPendapatanLainLain = await signInPendapatanLainLain(email);
  if (resPendapatanLainLain["code"] == 200) {
    var data = resPendapatanLainLain["data"];
    localStorage.setItem("pendapatan_lain_lain", JSON.stringify(data));
  }

  // E-PNBP KPU/USO
  const resKpuUso = await signInKpuUso(email);
  if (resKpuUso["code"] == 200) {
    var data = resKpuUso["data"];
    localStorage.setItem("kpu_uso", JSON.stringify(data));
  }

  // Jasa Perbankan
  const resBank = await signInJasaPerbankan(email);
  if (resBank["code"] == 200) {
    var data = resBank["data"];
    localStorage.setItem("jasa_perbankan", JSON.stringify(data));
  }

  // send token to cloud pendapatan
  await sendToken();
}

async function signInPendapatanLainLain(credentials) {
  return fetch(
    process.env.REACT_APP_HOST_PENDAPATAN_LAIN_LAIN + "/api/sso/signin",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    }
  ).then((data) => data.json());
}

async function signInKpuUso(credentials) {
  return fetch(process.env.REACT_APP_HOST_KPU_USO + "/api/sso/signin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
}

async function signInJasaPerbankan(credentials) {
  return fetch(process.env.REACT_APP_HOST_JASA_PERBANKAN + "/api/sso/signin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
}

async function sendToken() {
  const credentialKerjasamaBu = JSON.parse(
    localStorage.getItem("kerjasama_bu")
  );
  const credentialPendapatanLainLain = JSON.parse(
    localStorage.getItem("pendapatan_lain_lain")
  );
  const credentialKpuUso = JSON.parse(localStorage.getItem("kpu_uso"));
  const credentialBank = JSON.parse(localStorage.getItem("jasa_perbankan"));

  var params = {
    session: localStorage.getItem("client_id"),
    token_kpuuso: credentialKpuUso ? credentialKpuUso["token"] : null,
    token_kerjasamabu: credentialKerjasamaBu
      ? credentialKerjasamaBu["token"]
      : null,
    token_pendapatanlainlain: credentialPendapatanLainLain
      ? credentialPendapatanLainLain["token"]
      : null,
    token_perbankan: credentialBank ? credentialBank["token"] : null,
  };

  return fetch(
    process.env.REACT_APP_HOST_CLOUD_PENDAPATAN + "/api/portal/post-data-login",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }
  ).then((data) => data.json());
}

export default AuthUser;
